/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_Src_3_DetailInputs */

const en_wb_management_src_3_detail = /** @type {(inputs: Wb_Management_Src_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owners and next steps`)
};

const lv_wb_management_src_3_detail = /** @type {(inputs: Wb_Management_Src_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbildīgie un nākamie soļi`)
};

/**
* | output |
* | --- |
* | "Owners and next steps" |
*
* @param {Wb_Management_Src_3_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_src_3_detail = /** @type {((inputs?: Wb_Management_Src_3_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_Src_3_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_src_3_detail(inputs)
	return en_wb_management_src_3_detail(inputs)
});